(() => {
    const SWATCHES_BOX = '.swatches__box';
    const TOGGLE_BUTTON = '.swatches__toggle';
    const SWIPER_CONTAINER = '.pdp__carousel';
    const PAGINATION_EL = '.swiper-pagination-default';
    const BULLET_SELECTOR = '.pagination--desktop .swiper-pagination-bullet';
    const VARIANT_TITLE = '#variantTitle';

    let swiperInstance = null;

    const updateVariantTitle = (variantTitle) => {
        const titleElement = document.querySelector(VARIANT_TITLE);
        if (titleElement) {
            titleElement.textContent = variantTitle;
        }
    };

    const updateSelectedStates = (selectedVariantId) => {
        const colorChips = document.querySelectorAll('.color-chip__box');
        colorChips.forEach(chip => {
            chip.classList.toggle('is-selected', chip.dataset.variantId === selectedVariantId);
        });

        const swatchItems = document.querySelectorAll('.swatches__item');
        swatchItems.forEach(item => {
            const chip = item.querySelector('.color-chip__box');
            item.classList.toggle('is-selected', chip?.dataset.variantId === selectedVariantId);
        });
    };

    const updateSwiperImages = (thumbUrls,variantIndex) => {
        if (!thumbUrls) return;

        try {
            let urls;
            
            if (typeof thumbUrls === 'string') {
                try {
                    urls = JSON.parse(thumbUrls);
                } catch (e) {
                    urls = thumbUrls.split(',').map(url => url.trim()).filter(url => url);
                }
            } else if (Array.isArray(thumbUrls)) {
                urls = thumbUrls;
            } else {
                return;
            }
            
            if (!Array.isArray(urls) || urls.length === 0) return;

            if (swiperInstance) {
                swiperInstance.removeAllSlides();
                
                const slides = urls.map(url => `
                    <div class="swiper-slide">
                        <div class="pdp__img-box">
                            <img
                                class="pdp__img"
                                src="${url}"
                                alt="Product media"
                            >
                        </div>
                    </div>
                `);
                
                swiperInstance.appendSlide(slides);
                
                const totalSlidesCount = swiperInstance.slides.length;

                variantIndex = Math.min((totalSlidesCount-1),variantIndex);

                swiperInstance.slideTo(variantIndex, 300);
            }

            const thumbnailPagination = document.querySelector('#variant-thumbnails');
            if (thumbnailPagination) {
                thumbnailPagination.innerHTML = '';
                
                urls.forEach((url, index) => {
                    const button = document.createElement('button');
                    button.type = 'button';
                    button.className = `swiper-pagination-bullet ${index === variantIndex ? 'swiper-pagination-bullet-active' : ''}`;
                    button.dataset.index = index;
                    
                    let thumbUrl = url;
                    if (url.includes('shopify')) {
                        // thumbUrl = url.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_80x80$1$3');
                    }
                    
                    button.innerHTML = `
                        <span class="pdp__thumb-box">
                            <img
                                src="${thumbUrl}"
                                class="pdp__thumb"
                                alt="Thumbnail"
                            >
                        </span>
                    `;
                    thumbnailPagination.appendChild(button);
                });
                
                thumbnailPagination.style.display = 'flex';
                thumbnailPagination.style.visibility = 'visible';
                thumbnailPagination.style.opacity = '1';
                
                setTimeout(() => {
                    activateBullets(swiperInstance);
                }, 100);
            }

        } catch (error) {
            console.error('Error updating swiper images:', error);
        }
    };

    const bindSwatches = () => {
        const swatchesBox = document.querySelector(SWATCHES_BOX);
        
        swatchesBox?.addEventListener('click', (e) => {
            const button = e.target.closest('.color-chip__box');
            if (!button) return;

            const variantId = button.dataset.variantId;
            const variantTitle = button.dataset.variantTitle;
            let thumbUrls = button.dataset.thumbs;
            const thumbnailIndexString = button.dataset.thumbnailIndex;
            let variantIndex = 0; // 최종 결과를 저장할 변수를 선언합니다.

            // 방어 코드: thumbnailIndexString이 존재하고 유효한 숫자로 파싱 가능한지 확인
            if (thumbnailIndexString && !isNaN(parseInt(thumbnailIndexString, 10))) {
            const thumbnailIndexNumber = parseInt(thumbnailIndexString, 10);
                variantIndex = thumbnailIndexNumber - 1;
            } 

            if (!thumbUrls || thumbUrls.trim() === '' || thumbUrls === '[]') {
                const swatchesContainer = document.querySelector('.pdp-header__swatches');
                const defaultThumbs = swatchesContainer?.dataset.defaultThumbs;
                if (defaultThumbs) {
                    thumbUrls = defaultThumbs;
                }
            }

            if (variantId) {
                updateVariantTitle(variantTitle);
                updateSelectedStates(variantId);
                
                if (thumbUrls && thumbUrls.trim() !== '') {
                    updateSwiperImages(thumbUrls,variantIndex);
                }
            }
        });
    };

    const bindSwatchesToggle = () => {
        const toggleBtn = document.querySelector(TOGGLE_BUTTON);
        const swatchBox = document.querySelector(SWATCHES_BOX);
        if (!toggleBtn || !swatchBox) return;

        toggleBtn.addEventListener('click', () => {
            const isActive = toggleBtn.classList.toggle('is-activated');
            toggleBtn.textContent = isActive ? '閉じる' : 'すべて見る';
            swatchBox.classList.toggle('is-folded', !isActive);
        });
    };

    const waitForImages = (container, callback) => {
        const images = container.querySelectorAll('img');
        if (!images.length) return callback();

        let loaded = 0;
        const checkLoaded = () => ++loaded === images.length && callback();

        images.forEach((img) => {
            img.complete ? checkLoaded() : (
                img.addEventListener('load', checkLoaded),
                    img.addEventListener('error', checkLoaded)
            );
        });
    };

    const activateBullets = (swiper) => {
        const bullets = document.querySelectorAll(BULLET_SELECTOR);

        bullets.forEach((b) => {
            b.addEventListener('click', () => {
                const index = Number(b.dataset.index);
                swiper.slideTo(index);
            });
        });

        swiper.on('slideChange', () => {
            bullets.forEach((b) => b.classList.remove('swiper-pagination-bullet-active'));
            document
                .querySelector(`${BULLET_SELECTOR}[data-index="${swiper.realIndex}"]`)
                ?.classList.add('swiper-pagination-bullet-active');
        });
    };

    const initSwiper = () => {
        const container = document.querySelector(SWIPER_CONTAINER);
        if (!container) return;

        waitForImages(container, () => {
            swiperInstance = new Swiper(container, {
                loop: false,
                speed: 500,
                preloadImages: false,
                lazy: {
                    loadOnTransitionStart: true,
                    loadPrevNext: true
                },
                pagination: {
                    el: '.swiper-pagination-default',
                    clickable: true
                },
                centeredSlides: true,
                slidesPerView: 1.4,
                spaceBetween: 10,
                breakpoints: {
                    960: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        centeredSlides: false,
                        effect: 'fade'
                    }
                },
                observer: true,
                observeParents: true,
                resizeObserver: true
            });

            container.classList.add('swiper-initialized');
            activateBullets(swiperInstance);
        });
    };

    const init = () => {
        bindSwatches();
        bindSwatchesToggle();
        initSwiper();
    };

    document.addEventListener('DOMContentLoaded', init);

    if (window.Shopify?.designMode) {
        ['shopify:section:load', 'shopify:block:select'].forEach(evt =>
            document.addEventListener(evt, init)
        );
    }
})();